var OasisServices = {

    validatorScorerServices: [
        {
            id: 'pps-grouper',
            name: 'PPS-GROUPER',
            url: 'http://reviewandsign.info:8085/pps-grouper/score'
        },
        {
            id: 'pps-plus',
            name: 'PPS-PLUS',
            url: 'http://reviewandsign.info:8085/pps-plus/analysis-pdf'
        },
        {
            id: 'vut',
            name: 'VUT',
            url: 'http://reviewandsign.info:8085/vut/validate'
        }
    ],

    getServicesList: function () {
        return this.validatorScorerServices;
    },

    getServiceById: function (serviceId) {
        var found = _.find(this.validatorScorerServices, function (service) {
            return service.id == serviceId;
        });

        return found ? found : null;
    }
};

module.exports = OasisServices;


//////////////////
// WEBPACK FOOTER
// ./app/data/oasis-services.js
// module id = 365
// module chunks = 0